export default __webpack_public_path__ + "static/media/3095.65b3dd29.jpg";